import React from 'react'
import PropTypes from 'prop-types'
import styled, { css } from 'styled-components'
import { H2, H3 } from '../../../typography'

const Wrapper = styled.div`
  text-align: ${props => (props.left ? 'left' : 'center')};
  margin-bottom: 40px;
`

export const Header = styled(H2)`
  ${props =>
    typeof props.margin === 'number'
      ? css`
          margin: ${props.margin}px;
        `
      : null}
  ${props =>
    props.isNewSection
      ? css`
          margin-top: 0;
        `
      : null}
`

export const Tagline = styled(H3)`
  margin-bottom: 3px;
`

const NewSectionIndicator = styled(Header)`
  margin-top: 10px;
  margin-bottom: 10px;
`

const NewText = styled.span`
  color: ${props => props.theme.colors.primary};
`

const SectionHeading = ({ heading, tagline, margin, isNewSection, ...props }) => (
  <Wrapper {...props}>
    {isNewSection && (
      <NewSectionIndicator>
        **<NewText>NEW</NewText>**
      </NewSectionIndicator>
    )}
    <Header isNewSection={isNewSection} margin={margin}>
      {heading}
    </Header>

    {tagline && <Tagline>{typeof tagline === 'function' ? tagline() : tagline}</Tagline>}
    {props.children}
  </Wrapper>
)

SectionHeading.propTypes = {
  heading: PropTypes.string.isRequired,
  tagline: PropTypes.oneOfType([PropTypes.string, PropTypes.func]),
}

export default SectionHeading
